import type { PromptTemplates } from "@go-novus/widget";

import type { ProactiveRuleDraft } from "#/features/settings";

/**
 * 预览里的主动提示该显示哪条规则的文案与预填问题：最后操作过的规则还在列表里
 * 就用它，否则回退到第一条已启用的规则；都没有就返回空，由挂件回退示例文字。
 */
export function selectPromptTemplates(
  rules: ProactiveRuleDraft[],
  operatedRuleId: string | undefined,
): PromptTemplates | undefined {
  const operated =
    operatedRuleId === undefined
      ? undefined
      : rules.find((rule) => rule.id === operatedRuleId);
  const rule = operated ?? rules.find((item) => item.enabled);
  return rule === undefined
    ? undefined
    : { promptTemplate: rule.prompt, questionTemplate: rule.question };
}
